module.exports = __webpack_public_path__ + "static/media/PS.6e1ae273.svg";